import i18n from "i18next"
import { initReactI18next } from "react-i18next"

import { i18nextOptions } from "/i18next.config"
import en from "@/locales/translation/en.json"

const resources = { en: { translation: en } }

i18n.use(initReactI18next).init({
  ...i18nextOptions,
  resources
})
